import { apiClient } from "./ApiConfig";

export const paymentApi = {
  createPayment: (body: any) => {
    return apiClient.post("/payment", body);
  },
  getAllPayment: () => {
    return apiClient.get("/payment");
  },
  updatePayment: (body: any) => {
    return apiClient.post("/payment/update", body);
  },
  updateDefaultPayment: (body: any) => {
    return apiClient.post("/payment/default", body);
  },
  createPaypalPayment: (body: any) => {
    return apiClient.post("/payment/paypal", body);
  },
  deletePayment: (id: any) => {
    return apiClient.post("/payment/delete", id);
  },
};
